<!--  -->
<template>
    <div class='container'>
        <el-tabs v-model="activeName"  type="border-card" @tab-click="handleClick">
            <el-tab-pane label="空调系统节能" name="first">
                <energy-base></energy-base>
            </el-tab-pane>
            <el-tab-pane label="水泵节能" name="second">
                <energy-pump></energy-pump>
            </el-tab-pane>
            <el-tab-pane label="电价分成" name="thrid">
                <energy-price></energy-price>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import EnergyBase from './EnergyBase'
import EnergyPump from './EnergyPump'
import EnergyPrice from './EnergyPrice'
export default {
    name:  'basesetting',
    data() {
        return {
            activeName: 'first'
        };
    },

    components: { EnergyPump, EnergyBase, EnergyPrice},

    computed: {},

    mounted() {},

    methods: {
        handleClick() {
			
        }
    }
}

</script>
<style lang='less' scoped>

</style>